import React, { useState, useEffect, useRef } from "react";
import { oneKlicks } from "../../../../SDK/oneclick";
import Getlocation from "../../../../Uitiles/Getlocation";
import "./TopRatedSpecialists.css";
import { getdoctorspecialities, getdoctoreducation, encryptId, addToWishlist } from "../../../../services/apiService";
import DoctorSpecialities from "./DoctorSpecialities";
import DoctorAvailable from "./DoctorAvailable";
import { Link } from "react-router-dom";
import formatDoctorName from "../../../../Uitiles/FormatName";
import ImageShow from "../../../../Uitiles/ImageShow";
import Feedbackcount from "../../../../Uitiles/Feedbackcount";
import { Button } from "antd";

const  TopRatedSpecialists = () => {
    const [doctors, setDoctors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [doctorEducations, setDoctorEducations] = useState({});
    const [expandedCards, setExpandedCards] = useState({});
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        fetchDoctors();
    }, []);

    const truncateAddress = (address) => {
        if (!address) return '';
        // Split address by commas and take first two parts
        const parts = address.split(',');
        if (parts.length > 2) {
            return parts.slice(0, 2).join(',') + '...';
        }
        return address;
    };

    const fetchDoctors = async () => {
        try {
            setLoading(true);
            let location = null;
            
            // Try to get user location, but don't fail if it's not available
            try {
                location = await Getlocation();
                console.log("get location", location);
            } catch (locationError) {
                console.warn('Location access failed, using default location:', locationError.message);
                // Use a default location (you can change this to your preferred default)
                location = {
                    latitude: 17.3850, // Hyderabad coordinates as default
                    longitude: 78.4867
                };
            }
            
            const tableSchema = "";
            const tableName = "users";
            const conditions = {
                user_type: "doctor",
                featured: 1,
                // id: 4875
            };
            const orderBy = "RAND()";  //doctor_default_location
            const search = {};
            const pagination = {};
            const margedata = [
                {
                    target_table: "doctor_experience_education",
                    target_column: "user_id",
                    target_value: "id",
                    target_label: "education"
                },
                {
                    target_table: "doctor_default_location",
                    target_column: "user_id",
                    target_value: "id",
                    target_label: "default_location"
                }
            ];
            
            // Only add range if we have location data
            let range = null;
            if (location && location.latitude && location.longitude) {
                range = {
                    latitude: location.latitude,
                    longitude: location.longitude,
                    radius: 50, // in kilometers
                    target_latitude: "latitude",
                    target_longitude: "longitude"
                };
            }
            
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata, range);

            console.log("TopRatedSpecialists response", response);
            if (!response.success) {
                throw new Error('Invalid response format from server');
            }

            setDoctors(response.data);

            console.log("TopRatedSpecialists response", doctors);
        } catch (error) {
            console.error('Error fetching doctors:', error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleWishlistClick = (doctorId) => {
        console.log('Wishlist clicked for doctor ID:', doctorId);
        // Add your wishlist logic here
    };

    const toggleCardExpansion = (doctorId) => {
        setExpandedCards(prev => ({
            ...prev,
            [doctorId]: !prev[doctorId]
        }));
    };

    const scrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: -400,
                behavior: 'smooth'
            });
        }
    };

    const scrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: 400,
                behavior: 'smooth'
            });
        }
    };

    if (loading) {
        return (<></>
        );
    }

    if (error) {
        return (
            <div className="error-container">
                <div className="error-content">
                    <i className="fas fa-exclamation-triangle"></i>
                    <h3>Oops! Something went wrong</h3>
                    <p>{error}</p>
                    <button onClick={fetchDoctors} className="retry-button">
                        <i className="fas fa-redo"></i>
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    

    const formatUrlString = (name) => {
        if (!name) return '';
        // Remove any existing 'dr' prefixes (case insensitive)
        let formattedName = name.replace(/^dr[-_\s]+/i, '');
        // Remove pipe symbols and HTML entities
        formattedName = formattedName.replace(/\|/g, '').replace(/&amp;/g, 'and');
        // Replace dots, spaces, and special characters with hyphens
        formattedName = formattedName.replace(/[.\s]+/g, '-');
        // Convert to lowercase
        formattedName = formattedName.toLowerCase();
        // Remove any duplicate hyphens
        formattedName = formattedName.replace(/-+/g, '-');
        // Remove leading and trailing hyphens
        formattedName = formattedName.replace(/^-+|-+$/g, '');
        return formattedName;
    };

    return (
        <section className="elementor-section elementor-top-section elementor-element elementor-element-aaffff7 elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="aaffff7" data-element_type="section" data-settings='{"stretch_section":"section-stretched"}'>
            <div className="elementor-container elementor-column-gap-no">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ed667b0" data-id="ed667b0" data-element_type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-8c20aa1 elementor-widget elementor-widget-dc_element_featured_doctors" data-id="8c20aa1" data-element_type="widget" data-widget_type="dc_element_featured_doctors.default">
                            <div className="elementor-widget-container">
                                <div className="dc-haslayout sc-top-reted">
                                    <div className="container">
                                        <div className="row justify-content-center align-self-center">
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 push-lg-2">
                                                <div className="dc-sectionhead dc-text-center">
                                                    <div className="dc-sectiontitle">
                                                        <h2>
                                                            <span>Meet Our Professionals</span>
                                                            Top Rated <em>Specialists</em>
                                                        </h2>
                                                    </div>
                                                    <div className="dc-description">
                                                        <p>Connect with the best medical professionals trusted for their expertise and quality care. Find specialists who prioritize your health, all in one place.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div className="dc-docfeatured">
                                                    {/* Scroll Navigation Buttons */}
                                                    <div className="doctors-scroll-container">
                                                        <button
                                                            className="scroll-btn scroll-btn-left"
                                                            onClick={scrollLeft}
                                                            aria-label="Scroll left"
                                                        >
                                                            <i className="fas fa-chevron-left"></i>
                                                        </button>
                                                        
                                                        <div className="doctors-scroll-wrapper" ref={scrollContainerRef}>
                                                            <div className="row doctors-row">
                                                                {doctors.map((doctor, index) => (
                                                                    <div key={doctor.id} className="col-12 col-sm-6 col-lg-4 col-xl-3 doctor-card-wrapper">
                                                                        <div className="dc-docpostholder">
                                                                            <Link to={`/doctor/${formatUrlString(doctor.display_name)}/${encryptId(doctor.id)}`}>
                                                                                <figure className="dc-docpostimg">
                                                                                    <ImageShow 
                                                                                        url={doctor.profile_photo_url}
                                                                                        type="doctor"
                                                                                        width={0}
                                                                                        height={0}
                                                                                        style={{ objectFit: "cover", width: "100%", height: "auto" }}
                                                                                    />
                                                                                    {/* Show "New" badge if doctor.created_at is within last 30 days */}
                                                                                   
                                                                                    {(() => {
                                                                                        const createdAt = new Date(doctor.created_at);
                                                                                        const now = new Date();
                                                                                        const diffDays = (now - createdAt) / (1000 * 60 * 60 * 24);
                                                                                        if (diffDays <= 30) {
                                                                                            return (
                                                                                                <figcaption>
                                                                                                    <span className="dc-featuredtag" title="Newly Joined">
                                                                                                        <i className="fa fa-bolt"></i> New
                                                                                                    </span>
                                                                                                </figcaption>
                                                                                            );
                                                                                        }
                                                                                        return null;
                                                                                    })()}
                                                                                </figure>
                                                                            </Link>
                                                                            <div className="dc-docpostcontent">
                                                                                <button 
                                                                                    className="dc-like dc-add-wishlist" 
                                                                                    onClick={() => addToWishlist(doctor.id)}
                                                                                >
                                                                                    <i className="far fa-heart"></i>
                                                                                </button>
                                                                                <div className="dc-title">
                                                                                    <div className="dc-doc-specilities-tag">
                                                                                        <DoctorSpecialities doctorId={doctor.id} />
                                                                                    </div>
                                                                                    <h3>
                                                                                        <Link to={`/doctor/${formatUrlString(doctor.display_name)}/${encryptId(doctor.id)}`}>
                                                                                            {formatDoctorName(doctor.display_name)}
                                                                                        </Link>
                                                                                        {doctor.is_verified && (
                                                                                            <>
                                                                                                <i className="icon-sheild dc-awardtooltip dc-tipso tipso_style" data-tipso="Medical Registration Verified"></i>
                                                                                                <i className="far fa-check-circle dc-awardtooltip dc-tipso tipso_style" data-tipso="Verified user"></i>
                                                                                            </>
                                                                                        )}
                                                                                    </h3>
                                                                                    <ul className="dc-docinfo">
                                                                                        <li style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                                            <i className="fas fa-graduation-cap"></i>
                                                                                            <em style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '100%' }}>
                                                                                                {(() => {
                                                                                                    try {
                                                                                                        // Handle multiple cases: array or object
                                                                                                        const educationsData =
                                                                                                        doctor?.education?.[0]?.educations || doctor?.education?.educations;

                                                                                                        if (!educationsData) {
                                                                                                        return doctor?.qualification || "";
                                                                                                        }

                                                                                                        // Try parsing JSON string if needed
                                                                                                        const educations =
                                                                                                        typeof educationsData === "string"
                                                                                                            ? JSON.parse(educationsData)
                                                                                                            : educationsData;

                                                                                                        if (!Array.isArray(educations)) {
                                                                                                        return doctor?.qualification || "";
                                                                                                        }

                                                                                                        // Render degree titles separated by commas
                                                                                                        return educations.map((edu, idx) => (
                                                                                                        <span key={edu.id || idx}>
                                                                                                            {edu.degree_title}
                                                                                                            {idx < educations.length - 1 ? ", " : ""}
                                                                                                        </span>
                                                                                                        ));
                                                                                                    } catch (error) {
                                                                                                        console.error("Error parsing education data:", error);
                                                                                                        return doctor?.qualification || "";
                                                                                                    }
                                                                                                    })()}

                                                                                            </em>
                                                                                        </li>
                                                                                        <Feedbackcount data={doctor} />
                                                                                        {/* <li>
                                                                                            <span className="dc-stars">
                                                                                                <span style={{width: "92%"}}></span>
                                                                                            </span>
                                                                                            <em>5.0 (1 Feedback)</em>
                                                                                        </li> */}
                                                                                    </ul>
                                                                                </div>
                                                                                <div className="dc-doclocation">
                                                                                    <span >
                                                                                        <i className="ti-direction-alt"></i>
                                                                                        {truncateAddress(doctor?.default_location?.address) || doctor.address || "Location not updated"}
                                                                                    </span>
                                                                                    <span>
                                                                                        <DoctorAvailable doctorId={doctor.id} />
                                                                                    </span>
                                                                                </div>
                                                                                <Button className="mt-3 dc-btn dc-btnactive wl-100 " style={{borderRadius: '100px'}}>View</Button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        
                                                        <button
                                                            className="scroll-btn scroll-btn-right"
                                                            onClick={scrollRight}
                                                            aria-label="Scroll right"
                                                        >
                                                            <i className="fas fa-chevron-right"></i>
                                                        </button>
                                                    </div>
                                                    
                                                    <div className="col-12 ">
                                                        <div className="dc-btnarea d-flex justify-content-center mt-0">
                                                            <Link to="/search-doctors/" className="dc-btn">Show All</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TopRatedSpecialists;
